<template>
    <el-row type="flex" class="header noselect" :class="{'anim': anim}" justify="center">
        <el-col :span="6"><div></div></el-col>
        <el-col :span="12">
            <div @click="goHome" class="clickeable">
                <img src="@/assets/LogoConcursos.png" height="100">
            </div>
        </el-col>
        <!--<el-col :span="6">
            <div style="text-align:initial">
                <h1 style="line-height: 60px;">Concursos</h1>
            </div>
        </el-col>-->
        <el-col :span="6">
            <div class="outer" v-if="!hideLogin">
                <div class="middle">
                    <div class="inner" align="right">
                        <div v-if="logged">
                            <div>
                                 <el-button type="danger" size="mini" @click="doLogout" plain  v-loading="loading">Salir</el-button>
                            </div>
                            <div class="username">
                                <el-dropdown @command="handleUserCommand">
                                    <span class="el-dropdown-link">
                                        {{username}}
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                        <el-dropdown-item command="profile">Perfil</el-dropdown-item>
                                        <el-dropdown-item command="teams">Equipos</el-dropdown-item>
                                        <el-dropdown-item command="logout" divided>Salir</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                            <!--<div>
                                <el-avatar size="medium" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
                            </div>-->
                        </div>
                        <div v-else>
                            <div class="username">
                                <el-button plain @click="$router.push('/login')">Ingresar</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-col>
    </el-row>
</template>

<script>

import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'Header',
    data() {
        return {
            anim: false,
            hideLogin: false,
            loading: false
        }
    },
    beforeMount() {
        this.$router.beforeEach((to, from, next) => {
			if (to.name == "login") {
                this.hideLogin = true;
			} else {
                this.hideLogin = false;
            }

			next();
		})
    },
    mounted(){
        document.addEventListener("scroll", (e) => {
            this.anim = (e.srcElement.documentElement.scrollTop > 10);
        })
    },
    methods: {
		...mapActions([
			'logout'
        ]),
        handleUserCommand(cmd){
            switch (cmd) {
                case 'profile':
                    
                    break;
                case 'teams':
                    this.$router.push('/teams');
                    break;
                case 'logout':
                    this.doLogout();
                    break;
            
                default:
                    break;
            }
        },
        goHome(){
            this.$router.push('/');
        },
        doLogout(){
            this.loading = true;
            axios({
                method: 'GET',
                url: '/server/login.php?action=logout',
                data: {}
            }).then((response) => {
                if(response.data.error != 0){
                    this.$notify.error({
                        title: 'Error',
                        message: response.data.message,
                        offset: 115
                    });
                } else {
                    this.logout();
                    this.goHome();
                }
            })
            .catch(this.catchAxios)
            .then(() => {
                this.loading = false;
            });
        },
		catchAxios(error){
			console.log(error);
		}
    },
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters([
			'username',
			'img',
			'logged'
			// ...
		])
    }
}
</script>


<style scoped>
    .header {
        position: sticky;
        top: 0px;
        transition: all .4s ease-in-out;
        background-color: #22293300;
        z-index: 10;
    }

    .header.anim {
        background-color: #222933CC;
    }

    .outer {
        display: table;
        height: 100%;
        width: 100%;
    }

    .middle {
        display: table-cell;
        vertical-align: middle;
    }

    .inner {
        margin-left: auto;
        margin-right: 20px;
        line-height: 36px;
    }
    
    .inner > div > div {
        float: right;
    }

    .username {
        padding-left: 5px;
        padding-right: 5px;
    }
</style>

<style>

</style>